function mirrorOrSecondaryMirrorOnly() {
  const { mirror, secondaryTopxMirrored } = this.validator.input;
  return mirror === false || secondaryTopxMirrored === false;
}

export default {
  fn: mirrorOrSecondaryMirrorOnly,
  message: 'You cannot have both Bi-Directional Charting and Secondary Metric on the Negative Axis'
};
